var map = {
	"./analytics-active.svg": 1058,
	"./analytics.svg": 8507,
	"./bell-active.svg": 5045,
	"./bell-green.svg": 5060,
	"./bell.svg": 8926,
	"./bill-active.svg": 9257,
	"./bill.svg": 4650,
	"./burger.svg": 8866,
	"./card-active.svg": 622,
	"./card.svg": 9135,
	"./clients-active.svg": 8401,
	"./clients.svg": 9615,
	"./close.svg": 5168,
	"./dashboard-active.svg": 8134,
	"./dashboard.svg": 2055,
	"./fuel-planner-active.svg": 4445,
	"./fuel-planner.svg": 1750,
	"./references-active.svg": 4178,
	"./references.svg": 6315,
	"./reports-active.svg": 9645,
	"./reports.svg": 1510,
	"./stations-list-active.svg": 878,
	"./stations-list.svg": 5503,
	"./toggle.svg": 4197,
	"./upload-active.svg": 6097,
	"./upload.svg": 1410,
	"./users-active.svg": 2586,
	"./users.svg": 307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1949;